var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-stat-item',{attrs:{"metric":_vm.metric,"label":"Impressions"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('impressions-icon')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }